module.exports = __webpack_public_path__ + "static/RiskOfRain2-64270d66a37138c6fc93b796842ce4ab.webp";